import { useEffect, useState } from "react";

/**
 * The value, a beat after it stopped changing.
 *
 * For search boxes that feed a Convex query directly. Typing "Cotton Roll"
 * without this is eleven queries over a websocket, ten of whose results are
 * thrown away before anyone reads them — on the one bar of signal an operatory
 * actually has, that is the difference between a list that keeps up and a list
 * that lags behind the thumb.
 *
 * Only the *query* input is debounced. The text in the box stays immediate,
 * because a search field that echoes late reads as a broken keyboard.
 */
export function useDebouncedValue<T>(value: T, delayMs = 180): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
